interface ProgressRingProps {
  percentage: number;
  color?: string;
  size?: number;
}

/**
 * Global circular SVG progress ring.
 * Used on subject cards (size=44) and chapter cards (size=32).
 *
 * @param percentage  0–100
 * @param color       Stroke colour for the filled arc (default teal)
 * @param size        Diameter in px (default 44)
 */
export default function ProgressRing({
  percentage,
  color = '#00CBA9',
  size = 44,
}: ProgressRingProps) {
  const strokeWidth = size <= 32 ? 3 : 3.5;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="transform -rotate-90">
        {/* Track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          className="text-gray-100 dark:text-white/10"
          strokeWidth={strokeWidth}
        />
        {/* Progress arc */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={percentage > 0 ? color : 'transparent'}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.8s ease-in-out' }}
        />
      </svg>
    </div>
  );
}
